import { makeStyles, Theme } from '@material-ui/core';

const styles = makeStyles((theme: Theme) => ({
  dialog: {},
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  buttonStyle: {
    backgroundColor: 'transparent',
    border: '1px solid rgba(0, 0, 0, 0.87)',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 'bold',
  },
  buttonStyleBlack: {
    backgroundColor: 'black',
    border: '1px solid rgba(0, 0, 0, 0.87)',
    color: 'white',
    fontWeight: 'bold',
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      backgroundColor: '#e3e5e6',
    },
  },
  headerTitle: {
    fontSize: theme.spacing(2.75),
    fontWeight: 'bold',
    lineHeight: '32.02px',
  },
  headerSubtitle: {
    fontSize: theme.spacing(1.75),
    fontWeight: 'lighter',
    lineHeight: '20.02px',
  },
}));

export default styles;
